import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/ScrollerItem.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/index.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "group",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "group-name font-size-h2-large"
  }, [_vm._v(i18n.tc("462") + _vm._s(_vm.groupName))]), _c('view-box', {
    ref: "viewBox"
  }, [_c(__unplugin_components_0, {
    ref: "linkPersonList",
    attrs: {
      "is-px": "",
      "size": "mini",
      "total": _vm.list.length,
      "height": _vm.scrollerHight
    },
    on: {
      "on-pulldown-loading": _vm.onPulldownLoading,
      "on-pullup-loading": _vm.onPullupLoading
    }
  }, _vm._l(_vm.list, function (item) {
    return _c(__unplugin_components_1, {
      key: item.id,
      staticClass: "list-item",
      staticStyle: {
        "height": "5.8rem"
      },
      nativeOn: {
        "click": function ($event) {
          _vm.$router.push({
            name: 'GroupPerson',
            params: {
              id: parseInt(item.id)
            }
          });
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_vm._v(" " + _vm._s(item.phone) + " ")]), item.is_admin ? _c('span', {
      staticClass: "user-role"
    }, [_vm._v(i18n.tc("463"))]) : _vm._e()]);
  }), 1), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        _vm.showAddPerson = true;
      }
    }
  }, [_vm._v(i18n.tc("464"))])], 1)], 1), _c('confirm', {
    ref: "confirm",
    attrs: {
      "show-input": "",
      "title": i18n.tc("464")
    },
    on: {
      "on-confirm": _vm.onConfirm,
      "on-hide": function ($event) {
        _vm.showAddPerson = false;
      }
    },
    model: {
      value: _vm.showAddPerson,
      callback: function ($$v) {
        _vm.showAddPerson = $$v;
      },
      expression: "showAddPerson"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };